import { pxToRem } from '@/Client/Styles/pxToRem';
import { css, SerializedStyles } from '@emotion/react';
import { COLORS2, TYPOGRAPHY2 } from '../../Styles';

export type CountInputSize = 'small' | 'medium' | 'large';

export type CountInputStyles = {
  container: SerializedStyles;
  button: SerializedStyles;
  input: SerializedStyles;
  inputDisabled: SerializedStyles;
  /** Per-size overrides layered onto `input`. Omit entirely if the style set has a single fixed size. */
  inputSizes?: Partial<Record<CountInputSize, SerializedStyles>>;
};

export const DEFAULT_COUNT_INPUT_STYLES: CountInputStyles = {
  container: css`
    label: COUNT_INPUT_CONTAINER_STYLE;
    display: flex;
    height: 44px;
    align-items: center;
    background-color: var(--background);
  `,
  button: css`
    label: COUNT_BUTTON_STYLE;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border: none;
    background-color: ${COLORS2.alwaysDark.green};
    color: ${COLORS2.alwaysDark.text.white};
    cursor: pointer;
    user-select: none;
    ${TYPOGRAPHY2.largeBold}

    &:hover {
      background-color: ${COLORS2.alwaysDark.background.light};
    }

    &:active {
      background-color: ${COLORS2.alwaysDark.border};
    }
  `,
  input: css`
    label: COUNT_INPUT_STYLE;
    width: 100%;
    flex: 1;
    height: 44px;
    border-top: 1px solid ${COLORS2.alwaysDark.green};
    border-bottom: 1px solid ${COLORS2.alwaysDark.green};
    border-left: 0px solid ${COLORS2.alwaysDark.green};
    border-right: 0px solid ${COLORS2.alwaysDark.green};
    background-color: transparent;
    text-align: center;
    outline: none;
    color: var(--text);

    &::placeholder {
      color: var(--text2);
    }

    /* Hide number input spinner arrows */
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    /* Firefox */
    &[type=number] {
      -moz-appearance: textfield;
    }
  `,
  inputDisabled: css`
    label: COUNT_INPUT_STYLE_DISABLED;
    opacity: 0.5;
    border: 1px solid ${COLORS2.alwaysDark.gray};
  `,
  inputSizes: {
    small: css`
      ${TYPOGRAPHY2.xSmall}
      font-size: ${pxToRem(TYPOGRAPHY2.fontSize.xSmall)} !important;
    `,
    medium: css`
      ${TYPOGRAPHY2.medium}
      font-size: ${pxToRem(TYPOGRAPHY2.fontSize.medium)} !important;
    `,
    large: css`
      ${TYPOGRAPHY2.large}
      font-size: ${pxToRem(TYPOGRAPHY2.fontSize.large)} !important;
    `,
  },
};
